import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { secureAxios } from "../../_helpers/auth";
import { queryClient } from "../../_helpers/query";
import log from "cslog";

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

function getQuery(collection) {
    if (collection === "directus_users") {
        return "users";
    } else if (collection === "roles" || collection === "directus_roles") {
        return "roles";
    } else if (collection === "directus_files") {
        return "files";
    }
    return `items/${collection}`;
}

export const useItems = (collection, preset, enabled) => {
    return useQuery(
        ["items", collection],
        () => secureAxios.get(`/items/${collection}`).then((res) => res.data),
        {
            enabled: enabled,
        }
    );
};

export const useSingleItem = (collection, queryString, enabled) => {
    let query = `items/${collection}`;
    if (collection === "directus_users") {
        query = "users";
    }
    return useQuery(
        ["items", collection, queryString],
        () =>
            secureAxios.get(`/${query}${queryString}`).then((res) => res.data),
        {
            enabled: enabled,
        }
    );
};
export const useRandomTemplate = (preset, fields, limit) => {
    let query = `qe_pro_db/randomize?preset=${preset}&limit=${limit}&fields=${fields}`;

    return useQuery(["items", preset, query], () =>
        secureAxios.get(`/${query}`).then((res) => res.data)
    );
};

export const useItemsFine = (
    collection,
    fieldsString,
    enabled,
    refresh,
    with_meta = false
) => {
    let query = `items/${collection}`;
    if (collection === "directus_users") {
        query = "users";
    } else if (collection === "roles" || collection === "directus_roles") {
        query = "roles";
    } else if (collection === "directus_files") {
        query = "files";
    }
    return useQuery(
        ["items", collection, fieldsString],
        () =>
            secureAxios
                .get(`/${query}?${fieldsString}`)
                .then((res) => (with_meta ? res : res.data)),
        {
            enabled: enabled,
            staleTime: twentyFourHoursInMs,
            refetchInterval: refresh && refresh > 0 ? refresh * 1000 : false,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            // keepPreviousData: false,
        }
    );
};

export const useCreateItemMutation = (
    onSuccess = () => {},
    onError = () => {},
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return secureAxios
                .post(`/items/${data.collection}`, data.data)
                .then((res) => res.data);
        },
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(["items", variables.collection]);
                if (variables.extraInvalidate) {
                    console.log(variables.extraInvalidate, "Invaliding extra");
                    queryClient.invalidateQueries(variables.extraInvalidate);
                }
                onSuccess(data);
            },
            onSettled: onDone,
        }
    );
};

export const useDeleteItemMutation = (onSuccess = () => {}) => {
    return useMutation(
        (data) => {
            return secureAxios.delete(`/items/${data.collection}/${data.id}`);
        },
        {
            onSuccess: (data, variables) => {
                log.p("Mutation Success");
                queryClient.invalidateQueries(["items", variables.collection]);
                if (variables.extraInvalidate) {
                    console.log(variables.extraInvalidate, "Invaliding extra");
                    queryClient.invalidateQueries(variables.extraInvalidate);
                }
                onSuccess(data);
            },
        }
    );
};

export const useUpdateItemMutation = (
    onSuccess = () => {},
    onError = () => {},
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return secureAxios.patch(
                `/${getQuery(data.collection)}/${data.id}`,
                data.data
            );
        },
        {
            onSuccess: (data, variables) => {
                queryClient.invalidateQueries(["items", variables.collection]);
                onSuccess();
            },
            onSettled: onDone,
        }
    );
};

export const useUpdateItemsMutation = (
    onSuccess = () => {},
    onError = () => {},
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return secureAxios.patch(`/items/${data.collection}`, data.data);
        },
        {
            onSuccess: (data, variables) => {
                queryClient.invalidateQueries(["items", variables.collection]);
                onSuccess();
            },
            onSettled: onDone,
        }
    );
};
